import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pledges: [],
    loadedPledges: false,
    quantity: 50,
    selectedPledge: {},
    isLoading: false,
    pendingPledge: null,
    pledgesForFilter: [],
    pledgesForDonor: [],
    pledgesForDonorLoading: false,
    pledgesForPayment: [],
    pledgesForPaymentId: null,
    pledgesForParent: undefined,
    recurringPledges: [],
    loadedRecurringPledges: false,
    recurringQuantity: 50,
    selectedRecurringPledge: {},
    recurringIsLoading: false,
    recurringPledgesForFilter: [],
    recurringPledgesForDonor: [],
    recurringPledgesForPayment: [],
    recurringPledgesForParent: undefined,
    // School-specific state (charges)
    schoolCharges: [],
    loadedSchoolCharges: false,
    schoolChargesQuantity: 50,
    selectedSchoolCharge: {},
    schoolChargesIsLoading: false,
    schoolRecurringCharges: [],
    loadedSchoolRecurringCharges: false,
    schoolRecurringChargesQuantity: 50,
    selectedSchoolRecurringCharge: {},
    schoolRecurringChargesIsLoading: false,
}

const pledgesSlice = createSlice({
    name: "pledges",
    initialState,
    reducers: {
        loadPledges(state, action) {
            state.pledges = action.payload.pledges;
            state.loadedPledges = true;
            state.quantity = action.payload.pledges.length
            if(Object.keys(state.selectedPledge).length !== 0){
                var pledge = action.payload.pledges.find(pledge => pledge.PledgeID === state.selectedPledge.PledgeID)
                if(pledge){
                    state.selectedPledge = pledge
                }
            }
        },
        showMoreRows(state) {
            state.quantity = state.quantity + 50
        },
        showLessRows(state) {
            state.pledges = state.pledges.slice(0, state.quantity - 51)
            state.quantity = state.quantity - 50
        },
        loadPledgesForDonor(state, action){
            state.pledgesForDonor = action.payload.pledges
            if(Object.keys(state.selectedPledge).length > 0){
                const pledge = action.payload.pledges.find(p => p.PledgeID === state.selectedPledge.PledgeID)
                if(pledge){
                    state.selectedPledge = pledge
                }
            }
        },
        loadPledgesForParent(state, action){
            // Always set to an array, even if empty (to distinguish from undefined = not fetched)
            state.pledgesForParent = action.payload.pledges || []
        },
        resetPledgesForParent(state){
            state.pledgesForParent = undefined
        },
        loadPledgesForPayment(state, action){
            state.pledgesForPayment = action.payload.pledges
            state.pledgesForPaymentId = action.payload.paymentId || null
        },
        resetPledgesForPayment(state){
            state.pledgesForPayment = []
            state.pledgesForPaymentId = null
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload
        },
        setPledgeForDonorLoading(state, action){
            state.pledgesForDonorLoading = action.payload
        },
        setSelectedPledge(state, action) {
            if (action.payload) {
                const id = action.payload
                var selectedPledge = state.pledges.find(pledge => pledge.PledgeID === id)
                if (selectedPledge) {
                    state.selectedPledge = selectedPledge
                }
                else if (typeof action.payload === 'object') {
                    state.selectedPledge = action.payload
                }
                else{
                     selectedPledge = state.pledgesForDonor.find(pledge => pledge.PledgeID === id) 
                     if (selectedPledge) {
                        state.selectedPledge = selectedPledge
                    }
                }
            }
        },
        resetSelectedPledge(state) {
            state.selectedPledge = {}
        },
        setPendingPledge(state, action) {
            state.pendingPledge = action.payload
        },
        resetPendingPledge(state) {
            state.pendingPledge = null
        },
        loadRecurringPledges(state, action){
            state.recurringPledges = action.payload.pledges
            state.loadedRecurringPledges = true
            state.recurringQuantity = action.payload.pledges.length
        },
        showMoreRecurringRows(state) {
            state.recurringQuantity = state.recurringQuantity + 50
        },
        showLessRecurringRows(state) {
            state.recurringPledges = state.pledges.slice(0, state.recurringQuantity - 51)
            state.recurringQuantity = state.recurringQuantity - 50
        },
        setRecurringIsLoading(state, action) {
            state.recurringIsLoading = action.payload
        },
        setSelectedRecurringPledge(state, action){
            if (action.payload) {
                const id = action.payload
                var selectedPledge = state.recurringPledges.find(pledge => pledge.PledgeRecurringID === id)
                if (selectedPledge) {
                    state.selectedRecurringPledge = selectedPledge
                }
                else if (typeof action.payload === 'object') {
                    state.selectedRecurringPledge = action.payload
                }
                else{
                     selectedPledge = state.recurringPledgesForDonor.find(pledge => pledge.PledgeRecurringID === id) 
                     if (selectedPledge) {
                        state.selectedRecurringPledge = selectedPledge
                    }
                   }
            }
        },
        resetSelectedRecurringPledge(state) {
            state.selectedRecurringPledge = {}
        },

        loadRecurringPledgesForDonor(state, action){
            state.recurringPledgesForDonor = action.payload.pledges
        },
        loadRecurringPledgesForParent(state, action){
            // Always set to an array, even if empty (to distinguish from undefined = not fetched)
            state.recurringPledgesForParent = action.payload.pledges || []
        },
        resetRecurringPledgesForParent(state){
            state.recurringPledgesForParent = undefined
        },
        loadRecurringPledgesForPayment(state, action){
            state.recurringPledgesForPayment = action.payload.pledges
        },
        resetRecurringPledgesForPayment(state){
            state.recurringPledgesForPayment = []
        },
        resetPledgesLists(state){
            state.pledgesForDonor = []
            state.pledgesForPayment = []
            state.pledgesForPaymentId = null
            state.recurringPledgesForDonor = []
            state.recurringPledgesForPayment = []
        },
        removeDeletedPledge(state, action){
            state.pledges = state.pledges.filter(p => p.PledgeID !== action.payload)
            if(state.pledges.length > 0){
                state.pledges[0].TotalPledges -= 1
            }
        },
        removeDeletedRecPledge(state, action){
            state.recurringPledges = state.recurringPledges.filter(p => p.PledgeRecurringID !== action.payload)
            if(state.recurringPledges.length > 0){
                state.recurringPledges[0].TotalRecurring -= 1
            }
        },
        updatePledgeInLists(state, action) {
            // Update pledge in all lists where it exists
            const { pledgeId, updates } = action.payload;
            
            // Update in main pledges list
            const pledgeIndex = state.pledges.findIndex(p => p.PledgeID === pledgeId);
            if (pledgeIndex !== -1) {
                state.pledges[pledgeIndex] = { ...state.pledges[pledgeIndex], ...updates };
            }
            
            // Update in school charges list
            const schoolChargeIndex = state.schoolCharges.findIndex(p => p.PledgeID === pledgeId);
            if (schoolChargeIndex !== -1) {
                state.schoolCharges[schoolChargeIndex] = { ...state.schoolCharges[schoolChargeIndex], ...updates };
            }
            
            // Update in pledgesForDonor list
            const donorPledgeIndex = state.pledgesForDonor.findIndex(p => p.PledgeID === pledgeId);
            if (donorPledgeIndex !== -1) {
                state.pledgesForDonor[donorPledgeIndex] = { ...state.pledgesForDonor[donorPledgeIndex], ...updates };
            }
            
            // Update in pledgesForParent list
            if (state.pledgesForParent && Array.isArray(state.pledgesForParent)) {
                const parentPledgeIndex = state.pledgesForParent.findIndex(p => p.PledgeID === pledgeId);
                if (parentPledgeIndex !== -1) {
                    state.pledgesForParent[parentPledgeIndex] = { ...state.pledgesForParent[parentPledgeIndex], ...updates };
                }
            }
            
            // Update in pledgesForPayment list
            const paymentPledgeIndex = state.pledgesForPayment.findIndex(p => p.PledgeID === pledgeId);
            if (paymentPledgeIndex !== -1) {
                state.pledgesForPayment[paymentPledgeIndex] = { ...state.pledgesForPayment[paymentPledgeIndex], ...updates };
            }
        },
        updateRecurringPledgeInLists(state, action) {
            // Update recurring pledge in all lists where it exists
            const { pledgeId, updates } = action.payload;
            
            // Update in main recurring pledges list
            const pledgeIndex = state.recurringPledges.findIndex(p => p.PledgeRecurringID === pledgeId);
            if (pledgeIndex !== -1) {
                state.recurringPledges[pledgeIndex] = { ...state.recurringPledges[pledgeIndex], ...updates };
            }
            
            // Update in school recurring charges list
            const schoolChargeIndex = state.schoolRecurringCharges.findIndex(p => p.PledgeRecurringID === pledgeId);
            if (schoolChargeIndex !== -1) {
                state.schoolRecurringCharges[schoolChargeIndex] = { ...state.schoolRecurringCharges[schoolChargeIndex], ...updates };
            }
            
            // Update in recurringPledgesForDonor list
            const donorPledgeIndex = state.recurringPledgesForDonor.findIndex(p => p.PledgeRecurringID === pledgeId);
            if (donorPledgeIndex !== -1) {
                state.recurringPledgesForDonor[donorPledgeIndex] = { ...state.recurringPledgesForDonor[donorPledgeIndex], ...updates };
            }
            
            // Update in recurringPledgesForParent list
            if (state.recurringPledgesForParent && Array.isArray(state.recurringPledgesForParent)) {
                const parentPledgeIndex = state.recurringPledgesForParent.findIndex(p => p.PledgeRecurringID === pledgeId);
                if (parentPledgeIndex !== -1) {
                    state.recurringPledgesForParent[parentPledgeIndex] = { ...state.recurringPledgesForParent[parentPledgeIndex], ...updates };
                }
            }
            
            // Update in recurringPledgesForPayment list
            const paymentPledgeIndex = state.recurringPledgesForPayment.findIndex(p => p.PledgeRecurringID === pledgeId);
            if (paymentPledgeIndex !== -1) {
                state.recurringPledgesForPayment[paymentPledgeIndex] = { ...state.recurringPledgesForPayment[paymentPledgeIndex], ...updates };
            }
        },
        resetDonorsInfo(state) {
            state.recurringPledgesForDonor = []
            state.pledgesForDonor = []
        },
        // School charges reducers
        loadSchoolCharges(state, action){
            state.schoolCharges = action.payload.pledges
            state.loadedSchoolCharges = true
            state.schoolChargesQuantity = action.payload.pledges.length
        },
        setSchoolChargesIsLoading(state, action) {
            state.schoolChargesIsLoading = action.payload
        },
        setSelectedSchoolCharge(state, action){
            if (action.payload) {
                const id = action.payload
                var selectedCharge = state.schoolCharges.find(charge => charge.PledgeID === id)
                if (selectedCharge) {
                    state.selectedSchoolCharge = selectedCharge
                }
                else if (typeof action.payload === 'object') {
                    state.selectedSchoolCharge = action.payload
                }
            }
        },
        resetSelectedSchoolCharge(state) {
            state.selectedSchoolCharge = {}
        },
        // School recurring charges reducers
        loadSchoolRecurringCharges(state, action){
            state.schoolRecurringCharges = action.payload.pledges
            state.loadedSchoolRecurringCharges = true
            state.schoolRecurringChargesQuantity = action.payload.pledges.length
        },
        setSchoolRecurringChargesIsLoading(state, action) {
            state.schoolRecurringChargesIsLoading = action.payload
        },
        setSelectedSchoolRecurringCharge(state, action){
            if (action.payload) {
                const id = action.payload
                var selectedCharge = state.schoolRecurringCharges.find(charge => charge.PledgeRecurringID === id)
                if (selectedCharge) {
                    state.selectedSchoolRecurringCharge = selectedCharge
                }
                else if (typeof action.payload === 'object') {
                    state.selectedSchoolRecurringCharge = action.payload
                }
            }
        },
        resetSelectedSchoolRecurringCharge(state) {
            state.selectedSchoolRecurringCharge = {}
        },
        removeDeletedSchoolCharge(state, action){
            state.schoolCharges = state.schoolCharges.filter(p => p.PledgeID !== action.payload)
            if(state.schoolCharges.length > 0){
                state.schoolCharges[0].TotalPledges -= 1
            }
        },
        removeDeletedSchoolRecCharge(state, action){
            state.schoolRecurringCharges = state.schoolRecurringCharges.filter(p => p.PledgeRecurringID !== action.payload)
            if(state.schoolRecurringCharges.length > 0){
                state.schoolRecurringCharges[0].TotalRecurring -= 1
            }
        },
        resetState: () => initialState,
    },
});

export const pledgesActions = pledgesSlice.actions;

export default pledgesSlice;
